var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.94444C5 13.6025 10.3975 19 17.0556 19C17.3559 19 17.6537 18.989 17.9487 18.9674C18.2871 18.9426 18.4563 18.9302 18.6103 18.8416C18.7379 18.7681 18.8588 18.6379 18.9228 18.5053C19 18.3453 19 18.1585 19 17.7851V15.5939C19 15.2798 19 15.1228 18.9483 14.9882C18.9027 14.8693 18.8285 14.7634 18.7324 14.6799C18.6236 14.5853 18.4759 14.5317 18.1808 14.4243L15.6867 13.5174C15.3433 13.3925 15.1715 13.3301 15.0087 13.3407C14.865 13.35 14.7268 13.3991 14.6094 13.4823C14.4762 13.5766 14.3823 13.7333 14.1943 14.0466L13.5556 15.1111C11.4945 14.1777 9.8237 12.5047 8.88889 10.4444L9.95338 9.80575C10.2667 9.61777 10.4233 9.52377 10.5177 9.3906C10.6009 9.27317 10.65 9.13495 10.6593 8.99132C10.6699 8.82843 10.6075 8.65675 10.4826 8.31337L9.57566 5.81916C9.46833 5.52404 9.41467 5.37647 9.3201 5.26763C9.23656 5.17149 9.13069 5.09734 9.01179 5.05168C8.87719 5 8.72017 5 8.40614 5H6.2149C5.84146 5 5.65474 5 5.49465 5.07719C5.36206 5.14114 5.23189 5.26212 5.15843 5.38969C5.06975 5.54372 5.05736 5.71293 5.03258 6.05135C5.01099 6.34622 5 6.64405 5 6.94444Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phone-icon.508defdb4cd36762ba8d552982cbfa5e.svg";
export { ForwardRef as ReactComponent };